<div class="modal-container">
  <div class="modal-body">
    <div class="box-info">
      <div>
        <small
          >URL: <a [href]="site.url" target="_blank">{{ site.url }}</a></small
        >
      </div>
      <div>
        <small class="me-3"
          ><b>{{ site.venue_code }}</b></small
        >
        |
        <small class="ms-3"
          ><b>{{ site.map_id }}</b></small
        >
      </div>
    </div>
    <iframe [src]="url" height="600" width="100%"></iframe>
  </div>

  <div class="modal-footer">
    <button class="btn-secondary" (click)="onDismiss('cancel')">Close</button>
  </div>
</div>
